import { Box, Typography, Button } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import EmploymentHistoryCalendar from "./components/EmploymentHistoryCalendar";

type EmploymentType =
  | "Full time"
  | "intern"
  | "Pixel Pilot"
  | "Part time"
  | "contract";

interface EmploymentPeriod {
  id: number;
  position: string;
  employment_type: EmploymentType;
  start_date: string;
  end_date: string | null;
  is_current: boolean;
}

interface Employee {
  id: number;
  name: string;
  employmentHistory: EmploymentPeriod[];
}

export default function EmploymentHistoryView() {
  const navigate = useNavigate();

  // Dummy employee data
  const employees: Employee[] = [
    {
      id: 1,
      name: "John Smith",
      employmentHistory: [
        {
          id: 1,
          position: "Intern",
          employment_type: "intern" as EmploymentType,
          start_date: "2024-01-01",
          end_date: "2024-12-31",
          is_current: false,
        },
        {
          id: 2,
          position: "Full-time Developer",
          employment_type: "Full time" as EmploymentType,
          start_date: "2025-01-01",
          end_date: "2025-12-31",
          is_current: false,
        },
        {
          id: 3,
          position: "Pixel Pilot",
          employment_type: "Pixel Pilot" as EmploymentType,
          start_date: "2026-01-01",
          end_date: "2026-06-30",
          is_current: false,
        },
        {
          id: 4,
          position: "Senior Developer",
          employment_type: "Full time" as EmploymentType,
          start_date: "2026-07-01",
          end_date: null,
          is_current: true,
        },
      ],
    },
    {
      id: 2,
      name: "Jane Doe",
      employmentHistory: [
        {
          id: 1,
          position: "Intern Designer",
          employment_type: "intern" as EmploymentType,
          start_date: "2025-01-01",
          end_date: "2025-12-31",
          is_current: false,
        },
        {
          id: 2,
          position: "Full-time Designer",
          employment_type: "Full time" as EmploymentType,
          start_date: "2026-01-01",
          end_date: null,
          is_current: true,
        },
      ],
    },
    {
      id: 3,
      name: "Bob Johnson",
      employmentHistory: [
        {
          id: 1,
          position: "Contract Developer",
          employment_type: "contract" as EmploymentType,
          start_date: "2024-01-01",
          end_date: "2024-12-31",
          is_current: false,
        },
        {
          id: 2,
          position: "Full-time Developer",
          employment_type: "Full time" as EmploymentType,
          start_date: "2025-01-01",
          end_date: "2025-12-31",
          is_current: false,
        },
        {
          id: 3,
          position: "Pixel Pilot",
          employment_type: "Pixel Pilot" as EmploymentType,
          start_date: "2026-01-01",
          end_date: "2026-06-30",
          is_current: false,
        },
        {
          id: 4,
          position: "Part-time Developer",
          employment_type: "Part time" as EmploymentType,
          start_date: "2026-07-01",
          end_date: null,
          is_current: true,
        },
      ],
    },
    {
      id: 4,
      name: "Alice Williams",
      employmentHistory: [
        {
          id: 1,
          position: "Intern Developer",
          employment_type: "intern" as EmploymentType,
          start_date: "2025-06-01",
          end_date: "2025-12-31",
          is_current: false,
        },
        {
          id: 2,
          position: "Full-time Developer",
          employment_type: "Full time" as EmploymentType,
          start_date: "2026-01-01",
          end_date: null,
          is_current: true,
        },
      ],
    },
    {
      id: 5,
      name: "Charlie Brown",
      employmentHistory: [
        {
          id: 1,
          position: "Contract Developer",
          employment_type: "contract" as EmploymentType,
          start_date: "2024-01-01",
          end_date: "2024-12-31",
          is_current: false,
        },
        {
          id: 2,
          position: "Full-time Developer",
          employment_type: "Full time" as EmploymentType,
          start_date: "2025-01-01",
          end_date: "2025-12-31",
          is_current: false,
        },
        {
          id: 3,
          position: "Pixel Pilot",
          employment_type: "Pixel Pilot" as EmploymentType,
          start_date: "2026-01-01",
          end_date: "2026-06-30",
          is_current: false,
        },
        {
          id: 4,
          position: "Part-time Developer",
          employment_type: "Part time" as EmploymentType,
          start_date: "2026-07-01",
          end_date: null,
          is_current: true,
        },
      ],
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
          Back
        </Button>
        <Typography variant="h5" fontWeight="bold">
          Employee Employment History
        </Typography>
      </Box>

      <EmploymentHistoryCalendar employees={employees} singleUserView={false} />
    </Box>
  );
}